import { Link } from 'react-router-dom';

import type { marketingFooter } from '../../../../app/_shared/marketing/landingContent';
import { KynwardLogo } from '../brand/KynwardLogo';
import './marketingProduct.css';

type Column = (typeof marketingFooter.columns)[number];
type LinkItem = Column['links'][number];

type Props = {
  tag: string;
  columns: readonly Column[];
  onScrollToAnchor: (id: string) => void;
  year: number;
  /** Optional text link to download section — no store badge images in footer. */
  downloadHref?: string;
  downloadLabel?: string;
};

function FooterLink({
  item,
  onScrollToAnchor,
}: {
  item: LinkItem;
  onScrollToAnchor: (id: string) => void;
}) {
  if ('anchor' in item && item.anchor) {
    return (
      <button
        type="button"
        className="ml-footerCol__link"
        onClick={() => onScrollToAnchor(item.anchor)}>
        {item.label}
      </button>
    );
  }
  const href = 'href' in item ? item.href : '#';
  if (href.startsWith('mailto:') || href.startsWith('http')) {
    return (
      <a className="ml-footerCol__link" href={href} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    );
  }
  return (
    <Link className="ml-footerCol__link" to={href}>
      {item.label}
    </Link>
  );
}

export function MarketingFooterColumns({
  tag,
  columns,
  onScrollToAnchor,
  year,
  downloadHref,
  downloadLabel,
}: Props) {
  return (
    <div className="ml-footerCols">
      <div className="ml-footerCols__brand">
        <p className="ml-footerCols__mark">
          <KynwardLogo size={32} glow="subtle" className="ml-footerCols__logo" />
          <span className="ml-footerCols__wordmark">Kynward</span>
        </p>
        <p className="ml-footerCols__tag ml-text-body-secondary">{tag}</p>
        {downloadHref && downloadLabel ? (
          <a className="ml-footerCols__download ml-text-body-secondary" href={downloadHref}>
            {downloadLabel}
          </a>
        ) : null}
      </div>

      <div className="ml-footerCols__nav">
        {columns.map((col) => (
          <div key={col.title} className="ml-footerCol">
            <h3 className="ml-footerCol__title">{col.title}</h3>
            <ul className="ml-footerCol__list">
              {col.links.map((item) => (
                <li key={item.label}>
                  <FooterLink item={item} onScrollToAnchor={onScrollToAnchor} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="ml-footerCols__copy ml-text-meta">© {year} Elyxora Works</p>
    </div>
  );
}
